module.exports = __webpack_public_path__ + "ecde5e54812218e8c3df0b86faa82b12.webp";